import { render } from "./Panel_Unique.vue?vue&type=template&id=6236c8d7&scoped=true"
import script from "./Panel_Unique.vue?vue&type=script&lang=js"
export * from "./Panel_Unique.vue?vue&type=script&lang=js"

import "./Panel_Unique.vue?vue&type=style&index=0&id=6236c8d7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6236c8d7"]])

export default __exports__